"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_demi_1 = require("vue-demi");
const utils_1 = require("../../common/utils");
exports.default = (0, vue_demi_1.defineComponent)({
    name: 'DatePickerDropdown',
    props: {
        value: {
            type: String,
            default: ''
        },
        availableDates: {
            type: Array,
            required: true
        },
        placeholder: {
            type: String,
            default: '请选择日期'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: ['input', 'change'],
    setup(props, { emit }) {
        const dropdownRef = (0, vue_demi_1.ref)(null);
        const monthColumnRef = (0, vue_demi_1.ref)(null);
        const dayColumnRef = (0, vue_demi_1.ref)(null);
        // 下拉面板显示状态
        const dropdownVisible = (0, vue_demi_1.ref)(false);
        // 临时选中的值
        const tempValue = (0, vue_demi_1.ref)(props.value);
        // 选中的月份
        const selectedMonth = (0, vue_demi_1.ref)('');
        // 判断是否为英文
        const isEnglishLang = (0, utils_1.isEnglish)();
        // 月份列表
        const monthList = (0, vue_demi_1.computed)(() => {
            return (0, utils_1.extractMonths)(props.availableDates);
        });
        // 根据选中月份过滤的日期列表
        const filteredDates = (0, vue_demi_1.computed)(() => {
            if (!selectedMonth.value) {
                return [];
            }
            return (0, utils_1.filterDatesByMonth)(props.availableDates, selectedMonth.value);
        });
        // 显示文本
        const displayText = (0, vue_demi_1.computed)(() => {
            if (!props.value) {
                return props.placeholder;
            }
            return (0, utils_1.formatDate)(props.value);
        });
        // 判断日期是否禁用
        const isDateDisabled = (dateSlot) => {
            return !dateSlot.timeRanges || dateSlot.timeRanges.length === 0;
        };
        // 处理触发按钮点击
        const handleTriggerClick = () => {
            if (props.disabled) {
                return;
            }
            dropdownVisible.value = !dropdownVisible.value;
            if (dropdownVisible.value) {
                initSelection();
            }
        };
        // 初始化选中状态
        const initSelection = () => {
            if (props.value && props.value.length === 10) {
                tempValue.value = props.value;
                selectedMonth.value = props.value.substring(0, 7); // YYYY-MM
            }
            else if (monthList.value.length > 0) {
                // 如果没有选中值，默认选中第一个月份
                selectedMonth.value = monthList.value[0];
            }
            // 滚动到选中位置
            (0, vue_demi_1.nextTick)(() => {
                scrollToSelectedMonth();
                scrollToSelectedDay();
            });
        };
        // 处理月份选择
        const handleMonthSelect = (month) => {
            selectedMonth.value = month;
            // 切换月份后滚动日期列到顶部
            (0, vue_demi_1.nextTick)(() => {
                if (dayColumnRef.value) {
                    dayColumnRef.value.scrollTop = 0;
                }
            });
        };
        // 处理日期选择
        const handleDaySelect = (dateSlot) => {
            if (isDateDisabled(dateSlot)) {
                return;
            }
            tempValue.value = dateSlot.date;
            // 选择日期后立即关闭面板并触发事件
            emit('input', dateSlot.date);
            emit('change', dateSlot.date);
            dropdownVisible.value = false;
        };
        // 滚动到选中的月份
        const scrollToSelectedMonth = () => {
            if (!monthColumnRef.value || !selectedMonth.value) {
                return;
            }
            const selectedItem = monthColumnRef.value.querySelector('.date-picker-dropdown__item--selected');
            if (selectedItem) {
                selectedItem.scrollIntoView({ block: 'center' });
            }
        };
        // 滚动到选中的日期
        const scrollToSelectedDay = () => {
            if (!dayColumnRef.value || !tempValue.value) {
                return;
            }
            const selectedItem = dayColumnRef.value.querySelector('.date-picker-dropdown__item--selected');
            if (selectedItem) {
                selectedItem.scrollIntoView({ block: 'center' });
            }
        };
        // 点击外部关闭下拉面板
        const handleClickOutside = (event) => {
            if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
                dropdownVisible.value = false;
            }
        };
        // 监听 value 变化
        (0, vue_demi_1.watch)(() => props.value, (newVal) => {
            tempValue.value = newVal;
            if (newVal && newVal.length === 10) {
                selectedMonth.value = newVal.substring(0, 7);
            }
        });
        // 监听 availableDates 变化，重置选中的月份
        (0, vue_demi_1.watch)(() => props.availableDates, () => {
            selectedMonth.value = '';
            tempValue.value = '';
        });
        (0, vue_demi_1.onMounted)(() => {
            document.addEventListener('click', handleClickOutside);
        });
        (0, vue_demi_1.onBeforeUnmount)(() => {
            document.removeEventListener('click', handleClickOutside);
        });
        return {
            dropdownRef,
            monthColumnRef,
            dayColumnRef,
            dropdownVisible,
            tempValue,
            selectedMonth,
            isEnglishLang,
            monthList,
            filteredDates,
            displayText,
            isDateDisabled,
            handleTriggerClick,
            handleMonthSelect,
            handleDaySelect,
            formatMonthLabel: utils_1.formatMonthLabel,
            getDateLabel: utils_1.getDateLabel
        };
    }
});
//# sourceMappingURL=data:application/json;base64,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